
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certifications/[certificationSlug]/modules/[moduleSlug]",
      function () {
        return require("private-next-pages/certifications/[certificationSlug]/modules/[moduleSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certifications/[certificationSlug]/modules/[moduleSlug]"])
      });
    }
  